import { useState, useEffect } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { getEnv } from "../config";
import swal from "sweetalert";
import CountryDropdown from "./CountryDropdown"; // Adjust import path

function ContactUs() {
  const [selectedCountry, setSelectedCountry] = useState("");
  const [captchaStatus, setCaptchaStatus] = useState(false); // React Turnstile - reCaptcha
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company_name: "",
    country: selectedCountry,
    subject: "",
    message: "",
    sender: getEnv("REACT_APP_EMAIL_SENDER"),
    receiver: getEnv("REACT_APP_EMAIL_RECEIVER"),
    landing_page_country: "Philippines",
  });

  const [turnstileToken, setTurnstileToken] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("Handling change to FormData 📝");
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      country: selectedCountry,
    }));
  }, [selectedCountry]);

  const handleCountryChange = (countryCode) => {
    setSelectedCountry(countryCode);
  };

  // Turnstile callback functions
  const handleTurnstileSuccess = (token) => {
    setTurnstileToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // First, validate Turnstile token
      if (!turnstileToken) {
        swal(
          "Oops!",
          "Please verify that you're not a robot by completing the security check below.",
          "error",
        );
        setLoading(false);
        return;
      }

      // Submit form data and token to your backend API
      const urlencoded = new URLSearchParams({
        ...formData,
        "cf-turnstile-response": turnstileToken,
      });

      const response = await fetch(getEnv("REACT_APP_SEND_MAIL_URL"), {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: urlencoded.toString(),
      });

      const data = await response.json();

      if (response.ok) {
        // Clear form on success
        swal(
          "Thank you!",
          "Your message has been sent. Our team will review it and get back to you shortly.",
          "success",
        );
        setFormData({
          name: "",
          email: "",
          phone: "",
          company_name: "",
          country: "",
          message: "",
        });
        // Reset Turnstile
        window.turnstile.reset();
        setTurnstileToken("");
      } else {
        swal("Oops!", "Something went wrong! Please try again later.", "error");
        setLoading(false);
      }
    } catch (err) {
      swal("Oops!", "Something went wrong! Please try again later.", "error");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <section id="contact-us" className="contact-us">
      <div className="landing-closing">
        <h2>Want to dive right in?</h2>
        <p>
          Start sending messages right away with our free trial. NO credit card
          required.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="input-col">
            <div className="input-wrapper">
              <label htmlFor="">Name</label>
              <input
                type="name"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
              />
            </div>
            <div className="input-wrapper">
              <label htmlFor="tel">Contact number</label>
              <input
                type="tel"
                id="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="Your phone number"
              />
            </div>
          </div>
          <div className="input-col">
            <div className="input-wrapper">
              <label htmlFor="">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Your email address"
              />
            </div>
            <div className="input-wrapper">
              <label htmlFor="company">Company Name</label>
              <input
                type="text"
                id="company"
                name="company_name"
                value={formData.company_name}
                onChange={handleChange}
                placeholder="Your company name"
              />
            </div>
          </div>
          <div className="input-wrapper">
            <label htmlFor="">Country</label>
            <CountryDropdown onCountrySelect={handleCountryChange} />
          </div>
          <div className="input-wrapper">
            <label htmlFor="">Subject</label>
            <input
              type="subject"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="What is your inquiry about?"
            />
          </div>
          <div className="input-wrapper">
            <label htmlFor="">Message</label>
            <textarea
              type="name"
              id="name"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Write your message here..."
            />
          </div>
          <button type="submit">Submit</button>
          {/* Turnstile component */}
          <Turnstile
            siteKey={getEnv("REACT_APP_TURNSTILE_SITE_KEY")}
            options={{
              theme: "light",
            }}
            onError={() => setCaptchaStatus(false)}
            onExpire={() => setCaptchaStatus(false)}
            onSuccess={handleTurnstileSuccess}
          />
        </form>
      </div>
    </section>
  );
}

export default ContactUs;
